import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { CreateKitComponent } from './create-kit/create-kit.component';
import { ClientsComponent } from './clients/clients.component';
import { HardwareRegisterComponent } from './hardware-register/hardware-register.component';


const routes: Routes = [
  {
    path: 'users',
    component: UsersComponent,
    data: {
      identifier: 'users'
    }
  },
  {
    path: 'create-job',
    component: CreateKitComponent,
  },
  {
    path: 'clients',
    component: ClientsComponent,
  },
  {
    path: 'hardware-register',
    component: HardwareRegisterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementRoutingModule { }
